// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className='footer'>
      <p>&#169; 2022 #VANLIFE</p>
    </footer>
  );
}

export default Footer;
